import { useQuery } from '@tanstack/react-query';

import type { CreditTransaction } from '@ekhodealer/ekho-common';

import { useCurrentServicesProviderId } from '@common/hooks/useCurrentServicesProviderId';
import { apiClient } from '@config/server/apiClient';
import { planEndpoints } from '@config/server/apiEndpoints';
import { queries } from '@config/server/queryKeys';

export const getCredits = async (
	servicesProviderId: string,
	params: Record<string, string> = {},
): Promise<CreditTransaction[]> => {
	const year = parseInt(params.year ?? String(new Date().getFullYear()));
	const month = parseInt(params.month ?? String(new Date().getMonth()));

	const response = await apiClient.get<CreditTransaction[]>(
		planEndpoints.credits(servicesProviderId),
		{ params: { year: String(year), month: String(month) } },
	);
	return response.data;
};

/**
 * Hook for fetching credit transactions with optional filters
 */
export const useGetCredits = (params: Record<string, string> = {}) => {
	const servicesProviderId = useCurrentServicesProviderId();
	const year = parseInt(params.year ?? String(new Date().getFullYear()));
	const month = parseInt(params.month ?? String(new Date().getMonth()));

	return useQuery({
		queryKey: queries.credits.transactions(servicesProviderId, year, month).queryKey,
		queryFn: () => getCredits(servicesProviderId, params),
		enabled: Boolean(servicesProviderId),
		staleTime: 2 * 60 * 1000,
	});
};
